import {
    ComponentDescription,
    ComponentKind,
    TableColumn,
    LegacyPropertyDescription,
    MutatingScreenKind,
    hasInputContext,
    ActionKind,
    makeEmptyComponentDescription,
} from "../description";
import { SimpleComponentHandler, SimpleComponentDescription } from "./simple-handler";
import { MarkdownItemUI } from "../../components/uis";
import { getColumnProperty, makeColumnProperty } from "./property-utils";
import { makeTextPropertyDescriptor } from "./descriptor-utils";
import { getPrimitiveActionKinds } from "./primitive";

const ComponentKindMarkdown: ComponentKind = "markdown";
const componentName = "Rich Text";

interface MarkdownComponentDescription extends SimpleComponentDescription {
    readonly propertyName: LegacyPropertyDescription;
}

export class MarkdownComponentHandler extends SimpleComponentHandler {
    constructor() {
        super({
            kind: ComponentKindMarkdown,
            name: componentName,
            group: "Text",
            description: "Rich text with images",
            uiClass: MarkdownItemUI,
            img: "componentRichText",
            helpPath: "markdown",
        });
    }

    public get needsColumns(): boolean {
        return false;
    }

    protected getPropertyDescriptors(
        _desc: SimpleComponentDescription,
        mutatingScreenKind: MutatingScreenKind | undefined
    ) {
        return [
            {
                descriptor: () =>
                    makeTextPropertyDescriptor("propertyName", "Text", "Markdown text", true, mutatingScreenKind, {
                        isMultiLine: true,
                        preferredNames: ["text", "description", "markdown"],
                        preferredType: "markdown",
                        columnFirst: true,
                    }),
                argumentName: "markdown",
            },
        ];
    }

    protected getActionKinds(
        mutatingScreenKind: MutatingScreenKind | undefined,
        appHasUserProfile: boolean
    ): readonly ActionKind[] {
        return getPrimitiveActionKinds(hasInputContext(mutatingScreenKind), appHasUserProfile);
    }
}

export function defaultMarkdownComponent(column: TableColumn): MarkdownComponentDescription {
    return {
        ...makeEmptyComponentDescription(ComponentKindMarkdown),
        propertyName: makeColumnProperty(column.name),
        actions: [],
    };
}

export function getMarkdownColumnName(desc: ComponentDescription): string | undefined {
    if (desc.kind !== ComponentKindMarkdown) return undefined;
    return getColumnProperty((desc as MarkdownComponentDescription).propertyName);
}
